import { App } from 'vue'
import { logger } from '@/instance'
import { getDragHandler } from '@/utils/dom'

export default {
  install(app: App, opt: any) {
    app.directive('dragger', {
      /**
       * 模拟拖拽
       *
       * @param {*} el
       * @param {*} binding
       */
      mounted(el: any, binding) {
        const callback = binding.value
        const modifiers = binding.modifiers
        logger.log('plugins/dragger', 'dragger mounted', arguments)
        const draggerHandler = getDragHandler(callback, modifiers)
        el.onmousedown = draggerHandler
        el.ontouchstart = draggerHandler
      },
      beforeUnmount(el: any) {
        logger.log('plugins/dragger', 'dragger before unmounted', arguments)
        el.onmousedown = null
        el.ontouchstart = null
      },
    })
  },
}
